import RouteNames from "@/entities/RouteNames";
import NavigationIcons from "@/entities/NavigationIcons";
import RouteWrapper from "@/components/common/RouteWrapper.vue";
import { getChildRoutes } from "@/helpers/routes/getChildRoutes";
import BreadcrumbsTitles from "@/entities/BreadcrumbsTitles";
import { GetRelativeRoutes } from "@/entities/GetChildRoutes";
import Roles from "@/entities/Roles";
import sidebarData from "@/data/sidebar";
const contractor = sidebarData.find(
  (a) => a.role.includes(Roles.CONTRACTOR) && a.slug === "/empty"
);
const ContractorProject = () =>
  import("@/views/contractors/ContractorProjectNew.vue").then((m) => m.default);
const Details = () =>
  import("@/views/manage/projectDetails/DetailsNew.vue").then((m) => m.default);
const Activities = () =>
  import("@/views/clients/project/ActivitiesNew.vue").then((m) => m.default);
const Calendar = () =>
  import("@/views/clients/project/Calendar.vue").then((m) => m.default);
const CareLog = () =>
  import("@/views/clients/project/ClientCareLog.vue").then((m) => m.default);
const ClientProfile = () =>
  import("@/views/clients/project/ClientCareLog.vue").then((m) => m.default);
const ClientProjects = () =>
  import("@/views/clients/ClientProjectsNew.vue").then((m) => m.default);
const ClientProjectsAll = () =>
  import("@/views/clients/ClientProjectsAll.vue").then((m) => m.default);
const ClientProjectsVisits = () =>
  import("@/views/clients/ClientProjectsVisits.vue").then((m) => m.default);
const Documents = () =>
  import("@/views/clients/project/DocumentsNew.vue").then((m) => m.default);
const ProjectCarePlan = () =>
  import("@/views/manage/projectDetails/CarePlanNew.vue");

const getProjectsRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "/clients/contractors",
    component: RouteWrapper,
    meta: {
      breadcrumb: {
        title: contractor.title as string,
        routeName: RouteNames.CLIENT_VISITS,
        isStyled: true,
      },
    },
    // children: [
    //   {
    //     path: "",
    //     name: RouteNames.CONTRACTOR_PROJECTS,
    //     component: ClientProjects,
    //     meta: {
    //       title: "Contractor Projects",
    //       roles: [Roles.CONTRACTOR],
    //       breadcrumb: {
    //         isStyled: true,
    //       },
    //     },
    //   },
    // ],
  },
]);

const getProjectPrivatePageTabsRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "details",
    name: RouteNames.CONTRACTOR_PROJECT_DETAILS,
    component: Details,
    meta: {
      title: "Client Details",
      roles: [Roles.CONTRACTOR],
      breadcrumb: {
        isStyled: true,
      },
    },
  },
  {
    path: "activities",
    name: RouteNames.CONTRACTOR_PROJECT_ACTIVITY,
    component: Activities,
    meta: {
      title: "Client Visits",
      roles: [Roles.CONTRACTOR],
      breadcrumb: {
        isStyled: true,
      },
    },
  },
  {
    path: "client-profile",
    name: RouteNames.CONTRACTOR_PROJECT_CLIENT_PROFILE,
    component: ClientProfile,
    meta: {
      title: "Client Profile",
      roles: [Roles.CONTRACTOR],
      breadcrumb: {
        isStyled: true,
      },
    },
  },
  {
    path: "calendar",
    name: RouteNames.CONTRACTOR_PROJECT_CALENDAR,
    component: Calendar,
    meta: {
      title: "Client Visits",
      roles: [Roles.CONTRACTOR],
      breadcrumb: {
        isStyled: true,
      },
    },
  },
  {
    path: "care-log",
    name: RouteNames.CONTRACTOR_PROJECT_CLIENT_CARE_LOG,
    component: Activities,
    meta: {
      title: "Care log",
      roles: [Roles.CONTRACTOR],
      breadcrumb: {
        isStyled: true,
      },
    },
  },
  {
    path: "documents",
    name: RouteNames.CONTRACTOR_PROJECT_DOCUMENTS,
    component: Documents,
    meta: {
      title: "Client Documents",
      roles: [Roles.CONTRACTOR],
      breadcrumb: {
        isStyled: true,
      },
    },
  },
  {
    path: "project-care-plan",
    name: RouteNames.CONTRACTOR_PROJECT_CARE_PLAN,
    component: ProjectCarePlan,
    meta: {
      title: "Resource Care Plan",
      roles: [Roles.CONTRACTOR],
      breadcrumb: {
        isStyled: true,
      },
    },
  },
]);

const getProjectTabsVisitRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "visits",
    name: RouteNames.CLIENT_VISITS,
    component: ClientProjectsVisits,
    meta: {
      title: "Visits",
      roles: [Roles.CONTRACTOR],
      breadcrumb: {
        isStyled: true,
      },
    },
  },
]);

const getProjectTabsClientRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "all",
    name: RouteNames.CLIENT_All,
    component: ClientProjectsAll,
    meta: {
      title: "All",
      roles: [Roles.CONTRACTOR],
      breadcrumb: {
        isStyled: true,
      },
    },
  },
]);

const getProjectRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "",
    name: RouteNames.CONTRACTOR_PROJECTS,
    component: ClientProjects,
    meta: {
      title: "Resource Clients",
      roles: [Roles.CONTRACTOR],
      breadcrumb: {
        isStyled: true,
      },
    },
    children: [
      ...getProjectTabsVisitRoutes({}),
      ...getProjectTabsClientRoutes({}),
    ],
  },
  {
    path: ":id",
    component: ContractorProject,
    props: true,
    meta: {
      title: "Clients",
      roles: [Roles.CONTRACTOR],
      breadcrumb: {
        title: BreadcrumbsTitles.PROJECT_DETAILS,
        isStyled: true,
        classes: "project_details_in_contractor",
      },
    },
    children: [...getProjectPrivatePageTabsRoutes({})],
  },
]);
const getProjectPrivatePageRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "",
    component: RouteWrapper,
    meta: {
      title: "Clients",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        title: BreadcrumbsTitles.MANAGE_MAIN_CLIENTS,
        isStyled: true,
      },
    },
    children: [...getProjectRoutes({})],
  },
]);
export {
  getProjectPrivatePageRoutes,
  getProjectsRoutes,
  getProjectPrivatePageTabsRoutes,
};
